<template>
  <div class="awardContainer" :style="bgStyle">
    <div class="name">{{ couponName }}</div>
    <div
      class="amount"
      v-if="
        type === 'DISCOUNT_NO_CONDITION' || type === 'DISCOUNT_WITH_CONDITION'
      "
    >
      {{ awardData.detail.discountAmount | centToYuan
      }}<span class="unit">元</span>
    </div>
    <div class="amount" v-if="type === 'DISCOUNT_BY_RATE'">
      {{ awardData.detail.discountRate / 10 }}<span class="unit">折</span>
    </div>
    <div class="condition">{{ descText }}</div>
  </div>
</template>

<script>
import { centToYuan } from '../../helper';
// 折扣类型，1-立减券;2-折扣券 3-满减券
const COUPON_DICOUNT_TYPE = {
  1: 'DISCOUNT_NO_CONDITION',
  2: 'DISCOUNT_BY_RATE',
  3: 'DISCOUNT_WITH_CONDITION'
};

// 业务券类型：1-通用券，2-搬家券，3-大货车券，4-小B货运券，5-零担物流，6-司机会员优惠券
const COUPON_NAME = {
  1: '通用券',
  2: '搬家券',
  3: '大货车券',
  4: '货运券',
  5: '零担物流券',
  6: '司机会员优惠券'
};
export default {
  props: {
    awardData: {
      type: Object,
      required: true
    }
  },
  filters: {
    centToYuan
  },
  computed: {
    type() {
      if (
        this.awardData.detail.discountType === 1 &&
        (this.awardData.detail.thresholdAmount ||
          this.awardData.detail.reachFen)
      ) {
        return COUPON_DICOUNT_TYPE[3];
      }
      return COUPON_DICOUNT_TYPE[this.awardData.detail.discountType];
    },
    bgStyle() {
      return {
        background: `center / cover no-repeat url("${
          this.awardData.imgUrl[this.type]
        }")`
      };
    },
    couponName() {
      return COUPON_NAME[this.awardData.detail.businessType];
    },
    descText() {
      switch (this.type) {
        case 'DISCOUNT_NO_CONDITION':
          return '下单立减';
        case 'DISCOUNT_BY_RATE':
          return `最高减${centToYuan(this.awardData.detail.discountAmount)}元`;
        case 'DISCOUNT_WITH_CONDITION':
          return `满${centToYuan(this.awardData.detail.thresholdAmount)}元可用`;
        default:
          return '';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.awardContainer {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-size: inherit;
  color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 9% 0;
  line-height: normal;

  .name {
    font-size: 0.56em;
  }

  .amount {
    margin-top: -10%;
    font-size: 1em;
    font-family: 'Alibaba Zhixing';

    .unit {
      font-size: 0.63em;
    }
  }

  .condition {
    font-size: 0.56em;
  }
}
</style>
